export default {
  MUTATIONS: {
    SET_MAIL_UNREAD: 'setMailUnread'
  },
  ACTIONS: {
    COUNT_UNREAD: 'countUnread'
  }
};
